import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {AuthenticationService} from "../service/authentication-service";
import {AuthenticationResponse} from "../shared/model/response/auth/authentication-response.model";
import {AccessService} from "../service/api/access.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthenticationService,
    private accessService: AccessService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.headers.has("Skip-Interceptor")) {
      return next.handle(req)
    }

    if (this.authService.getAccessToken()) {

      if (this.authService.isExpired()) {
        this.accessService.refreshToken().subscribe({
          next: (response: AuthenticationResponse) => this.authService.setSession(response.accessToken),
          error: () => this.authService.removeSession()
        })
      }

      req = req.clone({
        headers: req.headers.set("Authorization", "Bearer " + this.authService.getAccessToken())
      })
    }

    return next.handle(req)
  }
}
